// v3.0.0-rc.8f — Cart Stream global state
// Reçoit les events SSE (venus de LiveBanner) et expose :
//  - depletedProducts : Set<product_id> passés en rupture stock (fade cards)
//  - onlineMerchants  : Set<merchant_id> qui viennent de passer en ligne
//  - onlineMerchantsSeen : compteur "non vu" pour la bell du halo
//
// Simple pub/sub in-memory. Sur reload page, s'efface (comportement OK :
// c'est de la sur-couche visuelle, pas de la donnée métier).

const EVENT = "aya-cart-stream-update";

const _state = {
  depleted: new Set(),
  online: [], // {merchant_id, name, ts}
  onlineSeen: 0, // index de la dernière bell "vue"
};

function _emit() {
  try { window.dispatchEvent(new CustomEvent(EVENT)); } catch (_) { /* noop */ }
}

export function pushDepleted(productId) {
  if (!productId) return;
  _state.depleted.add(productId);
  _emit();
}

export function pushMerchantOnline(payload) {
  if (!payload?.merchant_id) return;
  // Anti-doublon : purge les entrées de plus de 5 min et les mêmes merchant_id.
  const now = Date.now();
  _state.online = _state.online.filter((x) => now - x.ts < 5 * 60_000 && x.merchant_id !== payload.merchant_id);
  _state.online.push({ merchant_id: payload.merchant_id, name: payload.name, ts: now });
  _emit();
}

export function markOnlineSeen() {
  _state.onlineSeen = _state.online.length;
  _emit();
}

export function getState() {
  return {
    depleted: new Set(_state.depleted),
    online: _state.online.slice(),
    unseenOnline: Math.max(0, _state.online.length - _state.onlineSeen),
  };
}

export function subscribe(handler) {
  const wrap = () => handler(getState());
  window.addEventListener(EVENT, wrap);
  return () => window.removeEventListener(EVENT, wrap);
}
